import React, { PropTypes } from 'react'
import cn from 'classnames'

import WizardItem from './wizard-item'

const Wizard = ({ items, step, onClick }) => (
  <ul className="nav nav-wizard">
    {items.map((item, idx) => (
      <WizardItem
        key={'nav'+idx}
        title={item}
        step={idx}
        active={idx === step}
        onClick={onClick}
      />
    ))}
    <li className={cn({active: step === items.length})}>
      <button type="button" disabled>Complete</button>
    </li>
  </ul>
)

Wizard.propTypes = {
  items: PropTypes.array,
  step: PropTypes.number,
  onClick: PropTypes.func,
}

export default Wizard



// WEBPACK FOOTER //
// ./src/components/Wizard/index.js